import React from "react";
import {
  CommitmentIcon,
  CommitmentTitle,
  CommitmentTitleContainer,
  CommitmentTextContainer,
  CommitmentTextInnerContainer,
} from "./Commitment.style";
import PropTypes from "prop-types";

const CommitmentText = (props) => {
  return (
    <CommitmentTextInnerContainer reverse={props.reverse} mobileInverted={props.mobileInverted}>
      <CommitmentTitleContainer reverse={props.reverse} mobileInverted={props.mobileInverted}>
        <CommitmentTitle reverse={props.reverse} mobileInverted={props.mobileInverted}>
          {props.title}
          <CommitmentIcon
            iconProperties={props.iconProperties}
            reverse={props.reverse}
            mobileInverted={props.mobileInverted}
            src={props.icon}
          />
        </CommitmentTitle>
      </CommitmentTitleContainer>
      <CommitmentTextContainer reverse={props.reverse} mobileInverted={props.mobileInverted}>
        {props.text}
      </CommitmentTextContainer>
      {props.button}
    </CommitmentTextInnerContainer>
  );
};
CommitmentText.propTypes = {
  title: PropTypes.any,
  text: PropTypes.string,
  reverse: PropTypes.bool,
  mobileInverted: PropTypes.bool,
  background: PropTypes.any,
  icon: PropTypes.any,
  iconProperties: PropTypes.any,
  button: PropTypes.node,
};
export default CommitmentText;
